// extracted by mini-css-extract-plugin
export default {"innerCard":"Stopwatch_innerCard__eQWPq","footer":"Stopwatch_footer__PFLtW"};